import {
   sendTypingGoneStatus as sdkSendTypingGoneStatus,
   sendTypingStatus as sdkSendTypingStatus,
} from '@/infrastructure/sdk';
import { useCallback, useEffect, useRef } from 'react';

const TYPING_GONE_WAIT_MS = 1000;

export const useTypingStatus = activeChatJid => {
   const typingStatusSent = useRef(false);
   const typingTimeoutRef = useRef(null);

   const sendTypingGoneStatus = useCallback(() => {
      if (typingStatusSent.current) {
         sdkSendTypingGoneStatus(activeChatJid);
         typingStatusSent.current = false;
      }
      clearTimeout(typingTimeoutRef.current);
   }, [activeChatJid]);

   const sendTypingStatus = useCallback(() => {
      if (!typingStatusSent.current) {
         sdkSendTypingStatus(activeChatJid);
         typingStatusSent.current = true;
      }

      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = setTimeout(sendTypingGoneStatus, TYPING_GONE_WAIT_MS);
   }, [activeChatJid, sendTypingGoneStatus]);

   useEffect(() => {
      return () => {
         sendTypingGoneStatus();
      };
   }, [activeChatJid, sendTypingGoneStatus]);

   return { sendTypingStatus, sendTypingGoneStatus };
};
